module.exports = __webpack_public_path__ + "static/media/logo.caf36d34.png";